import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../../Helpers/configs';

import {
  expiryDate,
  convertDate,
  filterMethod,
} from '../../../Helpers/helpers';

// import { filterMethod } from '../../../Helpers/helpers';

import {
  Grid,
  Typography,
  TextField,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';

import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

const RepairTicketCabinetInfo = (props) => {
  const cabId = props.cabinetId;
  const fullSerialList = props.fullSerialList;
  const [history, setHistory] = useState([]);
  // const customer = props.customer;
  // const customerName = props.customerName;
  const customerName = props.customerName;
  const onBlurEventsCapture = props.onBlurEventsCapture;
  // const selectedStoreName = useState(props.selectedStoreName);
  const [cabinetData, setCabinetData] = useState(props.cabinetData);
  const [cabinetsList, setCabinetsList] = useState([]);

  const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState(
    []
  );

  const [cabinetType, setCabinetType] = useState([
    {
      id: cabinetData.cabId,
      name: cabinetData.cabType,
    },
  ]);
  const [serialNumber, setSerialNumber] = useState({
    id: cabinetData.serialId,
    name: cabinetData.serialNo,
    install_date: cabinetData.install_date,
  });
  // console.log(serialNumber);
  const [expiryDateVal, setExpiryDateVal] = useState('');

  const handleListChange = (event, newValue) => {
    const eventTarget = event.target.parentNode.id.split('-').shift();
    let eventValue = newValue;
    setAutocompleteValue(eventTarget, eventValue);
  };

  const setAutocompleteValue = (event, newValue) => {
    let blob;
    switch (event) {
      case 'cabinetType':
        let value = [];

        value = [...value, newValue];
        setCabinetType(value);
        setSerialNumber({});
        // sendCabinetBlob(cabId, newValue, serialNumber);
        // setSerialNumber({ id: '185696', name: 'No Serial Provided' });
        break;
      case 'serialNumber':
        setSerialNumber(newValue);
        const expDate =  calculateWarrantee(fullSerialList, newValue)
        sendCabinetBlob(cabId, cabinetType, newValue, expDate);
        break;
      default:
        break;
    }
    calculateWarrantee(fullSerialList, newValue.name);
    // console.log(cabinetBlob);
  };

  const [exp, setExp] = useState('');
  const handleExpChange = (event) => {
    setExp(event.target.value);
  };

  const sendCabinetBlob = (cabId, cabinetType, serialNumber, expDate = null) => {
    const cabIdNr = cabId;
    const cabType = cabinetType;
    const cabSerial = serialNumber;

    let eventValue = {
      id: cabIdNr,
      cabId: cabType[0].id,
      // cabId: cabType[0].id,
      cabType: cabType[0].name,
      serialId: cabSerial.id,
      serialNo: cabSerial.name,
      // exp: () => calculateWarrantee(fullSerialList, cabSerial.name),
      exp: expDate ?? expiryDateVal,
    };
    onBlurEventsCapture(cabIdNr, eventValue);
  };

  useEffect(() => {
    const serial = serialNumber;
    const data = fetchHistory(serial.id, setHistory);
    data === undefined ? setHistory([]) : setHistory(data);
  }, [serialNumber]);

  useEffect(() => {
    const serial = serialNumber;
    const serials = fullSerialList;
    calculateWarrantee(serials, serial);
  }, [fullSerialList, serialNumber]);

  const calculateWarrantee = (list, serial) => {
    const dateGroup = list.filter((cab) => {
      return cab.serial_number === serial.name;
    });

    const dateGroupObj = dateGroup[0];

    console.log(dateGroup[0]);

    let data =
      dateGroupObj === undefined
        ? ''
        : expiryDate(dateGroup[0].install_date, dateGroup[0].warranty_period);

    console.log(data);
    setExpiryDateVal(data);
    return data;
    // console.log(expiryDateVal);
  };

  useEffect(() => {
    let cabinetFilter = cabinetType[0].id;
    let customerFilter = customerName;
    if (
      cabinetFilter === null ||
      cabinetFilter === undefined ||
      cabinetFilter === ''
    ) {
      setFilteredSerialNumbersList([]);
    } else {
      serialsByCustomer(customerFilter, cabinetFilter).then((data) => {
        mapAvailableSerials(data.data.value);
      });
    }
  }, [cabinetType, customerName]);
  async function mapAvailableSerials(fullSerialList) {
    // console.log(fullSerialList);
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => {
      return {
        id: obj.id,
        name: obj.serial_number,
        install_date: obj.install_date,
      };
    });
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }
    setFilteredSerialNumbersList(distinctCabinetTypes);
  }

  useEffect(() => {
    let cabinetT = cabinetType;
    let cabinetTypes = [...props.cabinetsList];
    if (cabinetT === undefined || cabinetT === undefined || cabinetT === []) {
      setCabinetsList([{ id: '1001', name: 'No Info' }]);
    } else {
      setCabinetsList([...cabinetTypes]);
    }
  }, [cabinetType, props.cabinetsList]);

  const warranteeStatus = () => {
    if (!expiryDateVal) {
      return '';
    }

    let currentDate = new Date();
    let temp = expiryDateVal.split('/');
    let warranteeExpiry = new Date(temp[2], temp[1] - 1, temp[0]);
    return currentDate.getTime() < warranteeExpiry.getTime()
      ? 'In warrantee'
      : 'Out of warrantee';
  };

  return (
    <Grid
      container
      xs={12}
      md={12}
      flexDirection='row'
      rowGap={1}
      // columnGap={1}
      alignContent='flex-start'
    >
      <Grid
        container
        xs={11}
        md={11}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
        </Grid>
        <Grid item xs={12} md={2.0}>
          <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='cabinetType'
            key='cabinetType'
            id='cabinetType'
            variant='standard'
            size='small'
            value={cabinetType[0]}
            onChange={handleListChange}
            disablePortal
            options={cabinetsList || []}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>Serial Number:</Typography>
        </Grid>
        <Grid item xs={12} md={2.0}>
          <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='serialNumber'
            key='serialNumber'
            id='serialNumber'
            variant='standard'
            size='small'
            value={serialNumber || { id: '404', name: 'not defined' }}
            onChange={handleListChange}
            disablePortal
            options={filteredSerialNumbersList}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} md={1.3}>
          <Typography style={ticketTypoTitle}>Warrantee Expiry:</Typography>
        </Grid>
        <Grid item xs={12} md={1.0}>
          <Typography
            // value={expiryDateVal}
            id='expDate'
            // onChange={handleExpChange}
            style={ticketTypoInfo}
          >
            {expiryDateVal}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1.0}>
          <Typography style={ticketTypoTitle}>Status:</Typography>
        </Grid>
        <Grid item xs={12} md={1.0}>
          <Typography id='expStatus' style={ticketTypoInfo}>
            {warranteeStatus()}
          </Typography>
        </Grid>
        <Grid item xs={12} md={0.5}></Grid>

        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>History:</Typography>
        </Grid>

        <Grid item xs={12} md={10.3}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              background='#ffffff'
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>Repair History</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  size='small'
                  aria-label='a dense table'
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Repair Details</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {history.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {convertDate(row.ticket_date, 0, 10)}
                        </TableCell>
                        <TableCell>{row.description}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RepairTicketCabinetInfo;

async function serialsByCustomer(customerName, cabinetType) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
          {
            field: 'cabinet_type_id',
            search: cabinetType,
            strict: true,
          },
        ],
      },
    },
  };
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
